import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { ToastController } from "@ionic/angular";
import { from, Observable, throwError } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";

import { environment } from "../../environments/environment";
import firebase from "firebase/compat/app"; 
import "firebase/compat/auth" 

@Injectable()
export class HTTPInterceptor implements HttpInterceptor {
    private authToken: any;
    public fireUser?: firebase.User;

    constructor(public toastController: ToastController,
        public readonly auth: AngularFireAuth) {
          this.auth.authState.subscribe(user => {
            if (user) {
                this.fireUser = user;
            } else {
                console.error("No user signed in.");
            }
        });
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return from(this.retrieveToken()).pipe(
            switchMap(token => {
                let apiReq = req.clone({ url: `${environment.baseUrl}/${req.url}` });

                if (token) {
                    apiReq = apiReq.clone({
                        headers: apiReq.headers.set("Authorization", `Bearer ${token}`)
                    });
                }
                
                return next.handle(apiReq).pipe(
                    catchError(error => {
                        // Handle authentication errors gracefully
                        if (error.status === 401 || error.status === 403) {
                            console.warn(`Authentication error (${error.status}) for request: ${req.url}`);
                            // Don't throw the error for now, let the service handle it
                            return throwError(error);
                        }
                        return throwError(error);
                    })
                );
            }),
            catchError(error => {
                // If we can't get a token, still try the request without auth header
                console.warn("Could not retrieve token, proceeding without authentication");
                let apiReq = req.clone({ url: `${environment.baseUrl}/${req.url}` });
                return next.handle(apiReq);
            })
        );
    }

    private async retrieveToken(): Promise<string | null> {
        if (this.fireUser) {
            try {
                this.authToken = await this.fireUser.getIdToken();
                return this.authToken;
            } catch (error) {
                console.error("Error retrieving ID token:", error);
            }
        } else {
            console.warn("User not signed in or token unavailable.");
        }
        return null;
    }
}